<template>
  <PlaceholderPantalla
    titulo="Transferencias"
    subtitulo="Movimientos de dinero entre cuentas bancarias"
    descripcion="Gestiona las transferencias de fondos entre tus diferentes cuentas bancarias. El sistema actualiza automáticamente los saldos de ambas cuentas (origen y destino) y mantiene un registro detallado de todas las transferencias realizadas para control y auditoría."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../PlaceholderPantalla.vue'

const funcionalidades = [
  'Registrar transferencias entre cuentas propias',
  'Actualización automática de saldos en cuenta origen y destino',
  'Selección visual de cuenta origen y destino',
  'Conversión automática de monedas en transferencias internacionales',
  'Registro de comisiones bancarias asociadas a la transferencia',
  'Adjuntar comprobantes de transferencia',
  'Programar transferencias recurrentes automáticas',
  'Filtrar transferencias por fecha, cuentas involucradas',
  'Ver historial completo de transferencias con detalles',
  'Cancelación de transferencias programadas',
  'Exportar listado de transferencias',
  'Dashboard con flujo de dinero entre cuentas'
]

const datosManejados = [
  'Monto de la transferencia',
  'Fecha y hora de la transferencia',
  'Cuenta bancaria origen',
  'Cuenta bancaria destino',
  'Tipo de cambio (si aplica)',
  'Comisión bancaria',
  'Número de referencia bancaria',
  'Concepto o motivo de la transferencia',
  'Comprobante de transferencia',
  'Estado (completada, pendiente, cancelada)',
  'Programación (si es recurrente)',
  'Notas adicionales'
]
</script>
